import React from 'react';
import { Icon } from '@iconify/react';

const EmptyState = ({
  icon = 'solar:box-minimalistic-outline',
  title = 'No items found',
  description = 'There is no data to display right now.',
  action = null,
  className = ''
}) => {
  return (
    <div className={`hs-empty-state ${className}`}>
      <div className="hs-empty-icon">
        <Icon icon={icon} />
      </div>
      <h4 className="hs-empty-title">{title}</h4>
      {description && <p className="hs-empty-desc">{description}</p>}
      {action && <div className="mt-2">{action}</div>}
    </div>
  );
};

export default EmptyState;
